export default "__VITE_ASSET__b0de1c51__"